import React from 'react'

import HorizontalTabs from '../components/HorizontalTabs';
import { Link } from 'react-router-dom';


function news() {

  const tabs = [
    { title: 'News', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 className='title'>News</h1>
    </div>

    <div className='achivements-row'>

       <div className='achivement-box'>
           <div className='achivement-img'>
           <Link to="../img/news/Sports-day-2025.jpeg"
            target="_blank"
            rel="noopener noreferrer">
            <img src="../img/news/Sports-day-2025.jpeg"></img>
          </Link>
        </div>
       </div>
       <div className='achivement-box'>
           <div className='achivement-img'>
           <Link to="../img/news/Mumtaj-Cup.jpeg"
            target="_blank"
            rel="noopener noreferrer">
            <img src="../img/news/Mumtaj-Cup.jpeg"></img>
          </Link>
        </div>
       </div>
       <div className='achivement-box'>
           <div className='achivement-img'>
           <Link to="../img/news/Manisha-Mam-Achv.jpeg"
            target="_blank"
            rel="noopener noreferrer">
            <img src="../img/news/Manisha-Mam-Achv.jpeg"></img>
          </Link>
        </div>
       </div>
       <div className='achivement-box'>
           <div className='achivement-img'>
           <Link to="../img/news/Aryaman-Abhayraj.jpeg"
            target="_blank"
            rel="noopener noreferrer">
            <img src="../img/news/Aryaman-Abhayraj.jpeg"></img>
          </Link>
        </div>
       </div>
       <div className='achivement-box'>
           <div className='achivement-img'>
           <Link to="../img/news/School-Choir.jpeg"
            target="_blank"
            rel="noopener noreferrer">
            <img src="../img/news/School-Choir.jpeg"></img>
          </Link>
        </div>
       </div>
       <div className='achivement-box'>
           <div className='achivement-img'>
           <Link to="../img/news/Shifan-and-Manay.jpeg"
            target="_blank"
            rel="noopener noreferrer">
            <img src="../img/news/Shifan-and-Manay.jpeg"></img>
          </Link>
        </div>
       </div>
       <div className='achivement-box'>
           <div className='achivement-img'>
           <Link to="../img/news/APJ-Abdul-Kalam-Cup.jpeg"
            target="_blank"
            rel="noopener noreferrer">
            <img src="../img/news/APJ-Abdul-Kalam-Cup.jpeg"></img>
          </Link>
        </div>
       </div>
       <div className='achivement-box'>
           <div className='achivement-img'>
           <Link to="../img/news/Padamjaya01.jpeg"
            target="_blank"
            rel="noopener noreferrer">
            <img src="../img/news/Padamjaya01.jpeg"></img>
          </Link>
        </div>
       </div>

       <div className='achivement-box'>
           <div className='achivement-img'>
           <Link to="../img/news/Padamjaya-Shekhawat001.jpeg"
            target="_blank"
            rel="noopener noreferrer">
            <img src="../img/news/Padamjaya-Shekhawat001.jpeg"></img>
          </Link>
        </div>
       </div>

       <div className='achivement-box'>
           <div className='achivement-img'>
           <Link to="../img/news/Shifan-news-102.jpeg"
            target="_blank"
            rel="noopener noreferrer">
            <img src="../img/news/Shifan-news-102.jpeg"></img>
          </Link>
        </div>
       </div>

       <div className='achivement-box'>
           <div className='achivement-img'>
           <Link to="../img/news/SGFI-Basketball-202501.jpeg"
            target="_blank"
            rel="noopener noreferrer">
            <img src="../img/news/SGFI-Basketball-202501.jpeg"></img>
          </Link>
        </div>
       </div>

       <div className='achivement-box'>
           <div className='achivement-img'>
           <Link to="../img/news/Jangjeet001.jpeg"
            target="_blank"
            rel="noopener noreferrer">
            <img src="../img/news/Jangjeet001.jpeg"></img>
          </Link>
        </div>
       </div>

       <div className='achivement-box'>
           <div className='achivement-img'>
           <Link to="../img/news/Basketball-U-14-newss.jpeg"
            target="_blank"
            rel="noopener noreferrer">
            <img src="../img/news/Basketball-U-14-newss.jpeg"></img>
          </Link>
        </div>
       </div>

       <div className='achivement-box'>
           <div className='achivement-img'>
           <Link to="../img/news/Basketball-news-1103.jpeg"
            target="_blank"
            rel="noopener noreferrer">
            <img src="../img/news/Basketball-news-1103.jpeg"></img>
          </Link>
        </div>
       </div>

       <div className='achivement-box'>
           <div className='achivement-img'>
           <Link to="../img/news/Basketball-news-11102.jpeg"
            target="_blank"
            rel="noopener noreferrer">
            <img src="../img/news/Basketball-news-11102.jpeg"></img>
          </Link>
        </div>
       </div>
       
       <div className='achivement-box'>
           <div className='achivement-img'>
            <Link to="../img/news/basketball-news-1111.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src="../img/news/basketball-news-1111.jpeg"></img>
             </Link>
            </div>
        </div>
      
       <div className='achivement-box'>
           <div className='achivement-img'>
        <Link to="../img/news/Ice-Skating-_Anil.jpeg"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/Ice-Skating-_Anil.jpeg"></img>
          </Link>
        </div>
       </div>

              <div className='achivement-box'>
                  <div className='achivement-img'>
        <Link to="../img/news/news-Ice-skating.jpeg"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/news-Ice-skating.jpeg"></img>
          </Link>
        </div>

              </div>

                <div className='achivement-box'>
                    <div className='achivement-img'>
        <Link to="../img/news/Soni-Cup-1 (2).jpeg"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/Soni-Cup-1 (2).jpeg"></img>
          </Link>
        </div>

                </div>
                      <div className='achivement-box'>
                                <div className='achivement-img'>
        <Link to="../img/news/Soni-Cup-2-7.jpeg"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/Soni-Cup-2-7.jpeg"></img>
          </Link>
        </div>

                      </div>
                           <div className='achivement-box'>
                             <div className='achivement-img'>
        <Link to="../img/news/Ice-Skating.jpeg"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/Ice-Skating.jpeg"></img>
          </Link>
        </div>

                           </div>
                         

      <div className='achivement-box'>
     
    
        <div className='achivement-img'>
        <Link to="../img/news/NEWS_54.jpeg"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/NEWS_54.jpeg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>

      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/NEWS_47.jpeg"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/NEWS_47.jpeg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>

      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/NEWS_53.jpeg"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/NEWS_53.jpeg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>

      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/NEWS_48.jpeg"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/NEWS_48.jpeg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>

      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/NEWS_51.jpeg"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/NEWS_51.jpeg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>

      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/NEWS_45.jpeg"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/NEWS_45.jpeg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>

      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/NEWS_50.jpeg"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/NEWS_50.jpeg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>

      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/NEWS_46.jpeg"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/NEWS_46.jpeg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>

      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/NEWS_44.jpeg"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/NEWS_44.jpeg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>

      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/NEWS_40.jpeg"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/NEWS_40.jpeg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>

      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/NEWS_41.jpeg"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/NEWS_41.jpeg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>

      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/NEWS_39.jpeg"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/NEWS_39.jpeg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>

      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/NEWS_42.jpeg"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/NEWS_42.jpeg"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News01.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News01.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News02.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News02.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News03.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News03.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News14.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News14.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News15.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News15.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News16.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News16.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News171.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News171.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News04.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News04.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News05.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News05.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News06.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News06.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News07.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News07.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News08.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News08.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News09.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News09.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News10.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News10.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News11.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News11.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News12.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News12.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News13.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News13.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News18.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News18.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News19.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News19.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News20.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News20.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
   
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News21.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News21.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
     
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News22.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News22.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News23.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News23.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News24.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News24.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News25.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News25.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News26.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News26.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News27.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News27.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News28.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News28.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News29.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News29.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News30.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News30.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News31.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News31.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News33.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News33.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News34.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News34.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News35.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News35.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News36.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News36.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News37.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News37.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News38.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News38.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      
      
      <div className='achivement-box'>
        <div className='achivement-img'>
        <Link to="../img/news/News 8.webp"
          target="_blank"
          rel="noopener noreferrer">
            <img src="../img/news/News 8.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/News 9.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/News 9.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/News 7.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/News 7.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p></p>
        </div>
      </div>
      
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/Gold Medal at the Chetak Horse Show.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/Gold Medal at the Chetak Horse Show.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Gold Medal at the Chetak Horse Show</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/Graduation Ceremony 2018 held at Sanskar School.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/Graduation Ceremony 2018 held at Sanskar School.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Graduation Ceremony 2018 held at Sanskar School</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/Fr. Raymond Cricket Tournament.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/Fr. Raymond Cricket Tournament.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Fr. Raymond Cricket Tournament</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/Shambhavi Kumari's win in Skeet Shooting.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/Shambhavi Kumari's win in Skeet Shooting.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Shambhavi Kumari's win in Skeet Shooting</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/Shambhavi Kumari wins Silver medal.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/Shambhavi Kumari wins Silver medal.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Shambhavi Kumari wins Silver medal</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/Shambhavi Kumari wins Silver medal in S.N. Kapoor Shooting Championship.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/Shambhavi Kumari wins Silver medal in S.N. Kapoor Shooting Championship.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Shambhavi Kumari wins Silver medal in S.N. Kapoor Shooting Championship</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/Sanskar students win 52 medals in District level Skating competition.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/Sanskar students win 52 medals in District level Skating competition.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Sanskar students win 52 medals in District level Skating competition</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/Sanskar students win 23 medals in Skating.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/Sanskar students win 23 medals in Skating.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Sanskar students win 23 medals in Skating</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/Sanskar Students shine at Filmit India Film Festival 2017.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/Sanskar Students shine at Filmit India Film Festival 2017.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Sanskar Students shine at Filmit India Film Festival 2017</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/Sanskar students present Ramayan on stage.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/Sanskar students present Ramayan on stage.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Sanskar students present Ramayan on stage</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/Sanskar students present Ramayan on stage.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/Sanskar students present Ramayan on stage.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Sanskar students perform dance on Fusion Songs at Albert Hall</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/Sanskar School wins the 9th Kanni Thahryamal Inter School Cricket Tournament 2016.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/Sanskar School wins the 9th Kanni Thahryamal Inter School Cricket Tournament 2016.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Sanskar School wins the 9th Kanni Thahryamal Inter School Cricket Tournament 2016</p>
        </div>
      </div>
    
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/Sanskar School recognised as one of the TOP 50 SCHOOLS IN INDIA.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/Sanskar School recognised as one of the TOP 50 SCHOOLS IN INDIA.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Sanskar School recognised as one of the TOP 50 SCHOOLS IN INDIA</p>
        </div>
      </div>
    
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/Sanskar School Annual Sports Meet – a gala extravaganza.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/Sanskar School Annual Sports Meet – a gala extravaganza.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Sanskar School Annual Sports Meet – a gala extravaganza</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/Sanskar Guest Edition Special.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/Sanskar Guest Edition Special.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Sanskar Guest Edition Special</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/Sanskar Academy wins by 119 runs in under 19 tournament.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/Sanskar Academy wins by 119 runs in under 19 tournament.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Sanskar Academy wins by 119 runs in under 19 tournament</p>
        </div>
      </div>
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/Saniya Khan shines at Rajasthan Inter-District & State Junior Open Tennis Championship-2016.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/Saniya Khan shines at Rajasthan Inter-District & State Junior Open Tennis Championship-2016.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Saniya Khan shines at Rajasthan Inter-District & State Junior Open Tennis Championship-2016
          </p>
        </div>
      </div>
    
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/Republic Day Celebration at Sanskar School.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/Republic Day Celebration at Sanskar School.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Republic Day Celebration at Sanskar School          </p>
        </div>
      </div>
    
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/Pride of Sanskar Kamlesh Nagarkoti shines at Under-19 World Cup.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/Pride of Sanskar Kamlesh Nagarkoti shines at Under-19 World Cup.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Pride of Sanskar Kamlesh Nagarkoti shines at Under-19 World Cup</p>
        </div>
      </div>
      
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/Lawn and Table Tennis Tournament.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/Lawn and Table Tennis Tournament.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Lawn and Table Tennis Tournament</p>
        </div>
      </div>
    
      
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/Kavya Chandra of Sanskar School was awarded the 2nd Best Entry for her photograph.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/Kavya Chandra of Sanskar School was awarded the 2nd Best Entry for her photograph.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Kavya Chandra of Sanskar School was awarded the 2nd Best Entry for her photograph</p>
        </div>
      </div>
    
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/Kamlesh to play in Under-19 One-Day Series against England.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/Kamlesh to play in Under-19 One-Day Series against England.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Kamlesh to play in Under-19 One-Day Series against England</p>
        </div>
      </div>
    
      <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/Kamlesh to play in India Under - 19 Team.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/Kamlesh to play in India Under - 19 Team.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>Kamlesh to play in India Under - 19 Team</p>
        </div>
      </div>
      
      {/* <div className='achivement-box'>
        <div className='achivement-img'>
         <Link to="../img/news/British Council International School Award.webp"
          target="_blank"
          rel="noopener noreferrer">
          <img src="../img/news/British Council International School Award.webp"></img>
          </Link>
        </div>
        <div className='achivement-content'>
          <p>British Council International School Award</p>
        </div>
      </div> */}
    
  
    </div>

    </div> },
  ]
  return (
    <div>
   
      <div className='ibdp-hero-sec'>
        <img src='newimg/Screenshot_24.webp'/>

      </div>
      <div className="achievements-sec">

      <HorizontalTabs tabs={tabs} />
    </div>
    </div>  
  )
}

export default news
